import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { LocalizationService } from '../../localization/localization.service';
import { Locales } from '../../localization/locales';

const localization = {
  [Locales.ru]: {
    today: 'Сегодня',
    yesterday: 'Вчера',
    tomorrow: 'Завтра',
  },
  [Locales.en]: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
  }
};

@Pipe({
  name: 'mtgDate'
})
export class DatePipe implements PipeTransform {
  constructor(
    private localizationService: LocalizationService,
  ) {
  }

  transform(value: Date): any {
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    const date = new Date(value.getTime());
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const diff = today.getTime() - date.getTime();
    const days = Math.floor(Math.abs(diff / 86400000));
    if (days === 0) {
      return localization[this.localizationService.getLocale()].today;
    } else if (days === 1) {
      return diff < 0
        ? localization[this.localizationService.getLocale()].tomorrow
        : localization[this.localizationService.getLocale()].yesterday;
    }
    return formatDate(
      value,
      'dd MMM',
      this.localizationService.getLocale() as string
    );
  }
}
